<template>
  <v-content>
    <v-container class="candidate messages pt-0" style="max-width: 900px;">
      <v-card>
        <v-card-title :class="themes.candidate.light.dialogTitle">
          <div>
            <div class="headline">Messages</div>
            <div class="subheading" :class="themes.candidate.light.cardSubtitle">
              Correspondence relating to your applications
            </div>
          </div>
        </v-card-title>
        <v-card-text class="grey--text text--darken-2" v-if="!chats.length">
          You can view and respond to messages relating to your applications here once you receive one.
        </v-card-text>
      </v-card>

      <Conversation
        v-for="(application, applicationId) in applications"
        :key="`conversation-${applicationId}`"
        :application="application"
        :chats="applicationGroups[applicationId]"
      />
    </v-container>
  </v-content>
</template>

<script>
// Components
import Conversation from '@/components/Conversation'

// Helpers
import { mapGetters, mapState } from 'vuex'

// Vue Component
export default {
  components: { Conversation },
  created() {
    this.$store.dispatch('candidate/chats/fetchAll')
  },
  computed: {
    ...mapGetters({
      role: 'auth/role',
      user: 'auth/user',
      fullName: 'auth/fullName',
      profile: 'candidate/profile/model',
    }),
    ...mapState('candidate/chats', { chats: 'all' }),
    applicationGroups() {
      var groups = {}
      this.chats.forEach(chat => {
        if (!groups[chat.application.id]) {
          groups[chat.application.id] = []
        }

        groups[chat.application.id].push(chat)
      })
      return groups
    },
    applications() {
      var apps = {}
      this.chats.forEach(chat => {
        if (!apps[chat.application.id]) {
          apps[chat.application.id] = chat.application
        }
      })
      return apps
    },
    applicationsActive() {
      var apps = {}
      this.chats.forEach(chat => {
        if (!apps[chat.application.id]) {
          apps[chat.application.id] = (new Date(chat.application.opportunity.commencesAt) > new Date())
        }
      })
      return apps
    },
  },
}
</script>
